/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface FarmUserClaimRequestDto
 */
export interface FarmUserClaimRequestDto {
  /**
   *
   * @type {string}
   * @memberof FarmUserClaimRequestDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof FarmUserClaimRequestDto
   */
  userId: string;
  /**
   *
   * @type {string}
   * @memberof FarmUserClaimRequestDto
   */
  farmId: string;
  /**
   *
   * @type {string}
   * @memberof FarmUserClaimRequestDto
   */
  role: FarmUserClaimRequestDtoRoleEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum FarmUserClaimRequestDtoRoleEnum {
  RiverviewAdmin = "RIVERVIEW_ADMIN",
  RiverviewEmployee = "RIVERVIEW_EMPLOYEE",
  FarmAdmin = "FARM_ADMIN",
  FarmViewer = "FARM_VIEWER",
}
